import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getOperationEntitiesByGroupForDropDown,
    getReportData,
    retryOptionData
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}
async function getReportData(data) {
 
    const response = await CommonPost('/api/IntegrationOption/GetIntegrationRetry', null, data);
    return response.data;
}
async function retryOptionData(data) {
    const response = await CommonPost('/api/IntegrationOption/ManualLeafCollectionUpload', null, data);
    return response;
}



